/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Items_TitleInputs */

const id_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ms_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const da_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const de_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const en_us2_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const es_es2_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems`)
};

const es_mx2_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems`)
};

const fil_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Item`)
};

const fr_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const it_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articoli`)
};

const hu_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemek`)
};

const nl_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const no_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementer`)
};

const pl_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementy`)
};

const pt_br2_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens`)
};

const pt_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens`)
};

const ro_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemente`)
};

const fi_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohteet`)
};

const sv_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekt`)
};

const vi_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục`)
};

const tr_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğeler`)
};

const cs_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položky`)
};

const bg_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обекти`)
};

const ru_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объекты`)
};

const uk_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елементи`)
};

const ar_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العناصر`)
};

const hi_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम`)
};

const th_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการ`)
};

const ja_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテム`)
};

const zh_cn2_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const zh_hant1_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const ko_builds_items_title = /** @type {(inputs: Builds_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이템`)
};

/**
* | output |
* | --- |
* | "Items" |
*
* @param {Builds_Items_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_items_title = /** @type {((inputs?: Builds_Items_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Items_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_items_title(inputs)
	if (locale === "ms") return ms_builds_items_title(inputs)
	if (locale === "da") return da_builds_items_title(inputs)
	if (locale === "de") return de_builds_items_title(inputs)
	if (locale === "en-US") return en_us2_builds_items_title(inputs)
	if (locale === "es-ES") return es_es2_builds_items_title(inputs)
	if (locale === "es-MX") return es_mx2_builds_items_title(inputs)
	if (locale === "fil") return fil_builds_items_title(inputs)
	if (locale === "fr") return fr_builds_items_title(inputs)
	if (locale === "it") return it_builds_items_title(inputs)
	if (locale === "hu") return hu_builds_items_title(inputs)
	if (locale === "nl") return nl_builds_items_title(inputs)
	if (locale === "no") return no_builds_items_title(inputs)
	if (locale === "pl") return pl_builds_items_title(inputs)
	if (locale === "pt-BR") return pt_br2_builds_items_title(inputs)
	if (locale === "pt") return pt_builds_items_title(inputs)
	if (locale === "ro") return ro_builds_items_title(inputs)
	if (locale === "fi") return fi_builds_items_title(inputs)
	if (locale === "sv") return sv_builds_items_title(inputs)
	if (locale === "vi") return vi_builds_items_title(inputs)
	if (locale === "tr") return tr_builds_items_title(inputs)
	if (locale === "cs") return cs_builds_items_title(inputs)
	if (locale === "bg") return bg_builds_items_title(inputs)
	if (locale === "ru") return ru_builds_items_title(inputs)
	if (locale === "uk") return uk_builds_items_title(inputs)
	if (locale === "ar") return ar_builds_items_title(inputs)
	if (locale === "hi") return hi_builds_items_title(inputs)
	if (locale === "th") return th_builds_items_title(inputs)
	if (locale === "ja") return ja_builds_items_title(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_items_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_items_title(inputs)
	return ko_builds_items_title(inputs)
});
export { builds_items_title as "builds.items.title" }